import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	saveErrorTitle: {
		id: 'servicedesk-itsm-features.controllers.common.save-failed-flag.save-error-title',
		defaultMessage: "We couldn't turn {value, select, false {off} other {on}} {feature}",
		description: 'Title text of error flag',
	},
	saveErrorDescription: {
		id: 'servicedesk-itsm-features.controllers.common.save-failed-flag.save-error-description',
		defaultMessage: 'Refresh or try again.',
		description: 'Body text of error flag',
	},
	refreshAction: {
		id: 'servicedesk-itsm-features.controllers.common.save-failed-flag.refresh-action',
		defaultMessage: 'Refresh',
		description: 'Label used in refresh button in error flag that will refresh the page',
	},
});
